import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { Nillable } from '@web/utils';
import { AdminOrderItemComponentAttributeResponse } from './admin-order-item-component-attribute.response';
import { AdminOrderItemComponentSourceResponse } from './admin-order-item-component-source.response';

@jsonObject
export class AdminOrderItemComponentResponse {
  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(Number)
  public readonly quantity!: number;

  @jsonMember(MultimediaResponse)
  public readonly featuredFile?: Nillable<MultimediaResponse>;

  @jsonMember(AdminOrderItemComponentSourceResponse)
  public readonly source?: Nillable<AdminOrderItemComponentSourceResponse>;

  @jsonArrayMember(AdminOrderItemComponentAttributeResponse)
  public readonly attributes?: Nillable<
    AdminOrderItemComponentAttributeResponse[]
  >;
}
